import { YourOfferSalaryPage } from 'features/public-your-offer-salary/YourOfferSalaryPage';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { ServiceTechRole } from 'services/service.tech-roles';
import { ServiceTechs } from 'services/service.techs';
import { ServiceYearsOfExperience } from 'services/service.years-of-experience';
import { config } from 'utils/config';
import { getLocale } from 'utils/localize.utils';

export default YourOfferSalaryPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const [roles, techs, yearsOfExperience] = await Promise.all([
    ServiceTechRole.getAllAsListItemsRelevant(getLocale(locale), 'fake-token'),
    ServiceTechs.getAllAsListItems(getLocale(locale), 'fake-token'),
    ServiceYearsOfExperience.getAllAsListItemsWithKeyValue(
      getLocale(locale),
      'fake-token'
    )
  ]);

  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'your-offer-salary'
      ])),

      baseUrl: config.appUrl,
      roles: roles.map((role) => ({
        label: role.label,
        value: role.value.toString()
      })),
      techs: techs.map((tech) => ({
        label: tech.label,
        value: tech.value.toString()
      })),
      yearsOfExperience: yearsOfExperience
        .filter(({ value }) => value !== '>undefined')
        .map((role) => ({
          label: role.label,
          value: role.value.toString()
        }))
    },
    revalidate: 30
  };
};
